module.exports = __webpack_public_path__ + "static/media/gryphon_musee_everyartoriginal_5.7a577ca4.jpg";